// Autokana — tự sinh フリガナ (katakana) từ ô お名前 khi gõ tiếng Nhật qua IME.
// Bắt chuỗi hiragana đang compose (TRƯỚC khi convert sang kanji) → chuyển katakana →
// đổ vào ô kana. Chỉ auto khi user CHƯA tự sửa ô kana (tôn trọng nhập tay).
// Dùng: window.inkBindAutokana(nameEl, kanaEl).

(function () {
  'use strict';

  // ひらがな (U+3041–3096) → カタカナ (+0x60).
  function toKatakana(s) {
    return String(s || '').replace(/[ぁ-ゖ]/g, (c) => String.fromCharCode(c.charCodeAt(0) + 0x60));
  }

  window.inkBindAutokana = function (nameEl, kanaEl) {
    if (!nameEl || !kanaEl) return;
    let kana = '';           // hiragana đang compose (giữ bản trước khi convert kanji)
    let userEdited = false;  // user tự gõ ô kana → ngừng auto
    // `generated` = chuỗi katakana autokana đã sinh trong session này. Autokana CHỈ
    // ghi khi ô kana đang bằng `generated` (tức autokana đang sở hữu). Nếu ô kana có
    // sẵn giá trị khác (prefill lúc edit / user tự nhập) → KHÔNG đụng (tránh nối vào
    // furigana cũ làm hỏng: ヤマダタロウ → ヤマダタロウスズキ).
    let generated = '';

    // Programmatic set (autokana) KHÔNG phát 'input' → mọi input event = user thật.
    kanaEl.addEventListener('input', (e) => { if (e.isTrusted) userEdited = true; });

    nameEl.addEventListener('compositionstart', () => { kana = ''; });
    nameEl.addEventListener('compositionupdate', (e) => {
      // e.data = chuỗi compose hiện tại; giữ khi CÒN là hiragana (chưa convert kanji).
      const d = e.data || '';
      if (/^[ぁ-ゖー]*$/.test(d)) kana = d;
    });
    nameEl.addEventListener('compositionend', () => {
      // Chỉ auto khi: chưa bị user sửa + ô kana vẫn do autokana sở hữu (== generated,
      // gồm cả rỗng lúc đăng ký mới). Prefill (edit) → kanaEl.value != generated → bỏ qua.
      if (!userEdited && kana && kanaEl.value === generated) {
        generated += toKatakana(kana);
        kanaEl.value = generated;
      }
      kana = '';
    });

    // Xóa sạch ô name → reset (nếu autokana đang sở hữu ô kana) để nhập lại từ đầu.
    nameEl.addEventListener('input', () => {
      if (nameEl.value === '' && !userEdited && kanaEl.value === generated) {
        generated = '';
        kanaEl.value = '';
      }
    });
  };
})();
